import * as Actions from "./actions";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';
import { loadState } from "../../../../store/localStorage";
import moment from 'moment';

const fetchActiveDelivery = (payload) => (dispatch) => {

    loadState();

    return ApiService.post(Path.ORDER_ITEMS_GET_ACTIVE, payload)
        .then((response) => {
            window.scrollTo(0, 0);
            dispatch(Actions.setFilterDate(moment(response.data.data.activeDate)));
            dispatch(Actions.setList(response.data.data.orderList));
            return response.data;
        })
};

const fetchDefault = (payload) => (dispatch) => {
    return ApiService.get(Path.ORDER_ITEMS_GET_LIST, payload)
        .then((response) => {
            window.scrollTo(0, 0);
            dispatch(Actions.setList(response.data.data));
        });
};

const updateOrders = (list, loginId, deliveryDttm) => () => {
    return ApiService.post(Path.ORDER_ITEMS_GET_LIST + "/" + loginId + "/" + deliveryDttm + "/mobile", list)
        .then((response) => {
            return (response.data);
        })
};

const fetchProductOrders = (payload) => () => {
    return ApiService.post(Path.ORDER_ITEMS_CHECK, payload)
        .then((response) => {
            return (response.data);
        })
};

const updateMonthlyOrders = (list, loginId) => () => {
    return ApiService.post(Path.ORDER_ITEMS_GET_LIST + "/" + loginId, list)
        .then((response) => {
            return (response.data);
        })
};

const clearList = () => (dispatch) => {
    dispatch(Actions.setList([]));
}

const setFilterDate = (payload) => (dispatch) =>{
    dispatch(Actions.setFilterDate(payload));
}

const fetchDeadline = (proposalId, deliveryDttm) => () => {
    return ApiService.post(Path.ORDER_ITEMS_GET_LIST + "/" + proposalId + "/" + deliveryDttm)
        .then((response) => {
            return response.data.data;
        })
};

const fetchPredictionValues = (productCd, deliveryDt, payload) => () => {
    return ApiService.post(Path.PREDICTION + "/" + productCd +"/" + deliveryDt, payload)
        .then((response) => {
            return response.data.data;
        })
};

export {
    fetchActiveDelivery,
    fetchDefault,
    updateOrders,
    fetchProductOrders,
    updateMonthlyOrders,
    clearList,
    setFilterDate,
    fetchDeadline,
    fetchPredictionValues,
};
